import { Center, Spinner, Card } from '@chakra-ui/react'

import { WIDGET_MIN_HEIGHT } from '../DashboardWidget/DashboardWidget'

export const LoadingWidget: React.FC = () => {
  return (
    <Card variant="outline" borderRadius="base" boxShadow="none">
      <Center minH={WIDGET_MIN_HEIGHT}>
        <Spinner color="blue.500" />
      </Center>
    </Card>
  )
}
